import {
    GetManualSupplyOrdersQuery,
    GetManualSupplyOrderSupplierProductsStockVariationQuery,
} from 'data/__generated__';
import { ProductInfoTableRow } from 'pages/ManualSupplyOrders/sections/ProductInfoTableRow';
import { ManualSupplyOrdersFormData } from 'pages/ManualSupplyOrders/ManualSupplyOrdersForm';
import { useFieldArray, useFormContext } from 'react-hook-form';

// Composant pour gérer les products d'un supplyOrder avec useFieldArray
export const SupplyOrderProductsRows = ({
    supplyOrderIndex,
    originalSupplyOrder,
    allSupplyOrders,
    stockVariationData,
    stockVariationLoading,
    stockVariationError,
    updateForecastsLoading,
}: {
    supplyOrderIndex: number;
    originalSupplyOrder: GetManualSupplyOrdersQuery['manualSupplyOrders'][number];
    allSupplyOrders: {
        _id: string;
        name: string;
    }[];
    stockVariationData?: GetManualSupplyOrderSupplierProductsStockVariationQuery['manualSupplyOrderSupplierProductsStockVariation'];
    stockVariationLoading?: boolean;
    stockVariationError?: Error | null;
    updateForecastsLoading?: boolean;
}) => {
    const methods = useFormContext<ManualSupplyOrdersFormData>();
    const { fields: productsFields } = useFieldArray({
        control: methods.control,
        name: `supplyOrders.${supplyOrderIndex}.products`,
    });

    return (
        <>
            {productsFields.map((productField, productIndex) => {
                // Trouver le product correspondant dans les données originales
                const originalProduct = originalSupplyOrder.products.find((p) => p._id === productField._id);

                if (!originalProduct) return null;

                return (
                    <ProductInfoTableRow
                        key={productField.id}
                        supplyOrderIndex={supplyOrderIndex}
                        productIndex={productIndex}
                        supplier={originalSupplyOrder.supplier}
                        supplyOrderProduct={originalProduct}
                        productsInfoWithStock={originalSupplyOrder.productsInfoWithStock}
                        allSupplyOrders={allSupplyOrders}
                        stockVariationData={stockVariationData}
                        stockVariationLoading={stockVariationLoading}
                        stockVariationError={stockVariationError}
                        updateForecastsLoading={updateForecastsLoading}
                    />
                );
            })}
        </>
    );
};
